const NAME = "COLLABORATORS_SKILLS_RANKING_PAGE";

export default NAME;